export const getRateValue = (rate: number | null) => {
    if (typeof rate !== 'number' || Number.isNaN(rate)) return null;
    return Math.max(0, Math.min(5, Number(rate.toFixed(1))));
};

export const getDistanceValue = (distanceKm?: number | null) => {
    if (typeof distanceKm !== 'number' || Number.isNaN(distanceKm)) return null;
    return Number(distanceKm.toFixed(1));
};

export const formatDistance = (distanceKm: number) => {
    if (distanceKm < 1) {
        return `${Math.max(Math.round(distanceKm * 10) * 100, 100).toLocaleString('fa-IR')} متر`;
    }

    return `${distanceKm.toLocaleString('fa-IR', { maximumFractionDigits: 1 })} کیلومتر`;
};
